import type { IconSvgObject } from './types';

const CornerUpLeftIcon: IconSvgObject = [
  ["path", { d: "M9 14.002L4 9.00195L9 4.00195M5 9.00195L17 9.00195C18.6569 9.00195 20 10.3451 20 12.002L20 20.002", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default CornerUpLeftIcon;
